import { Route, Switch } from 'react-router-dom';

import Feedback from './Feedback';
import { FormStart } from './FormStart';
import { FormMultiRouter } from './formMultiRouter';
import { Form } from './Form';
import { FormEnd } from './FormEnd';
import { ReviewPage } from './Review';
import { RecommendationPage } from './Recommendation';
import { ReviewEditPage } from './Review/Edit';

export const routes: {
  [name: string]: {
    path: string;
    component: React.ComponentType<any>;
    exact?: boolean;
  };
} = {
  formMulti: {
    path: '/form/multi',
    component: FormMultiRouter,
  },
  legacyRoute: {
    path: '/form/:authenticationCode',
    exact: true,
    component: FormStart,
  },
  formStart: { path: '/form/:authenticationCode/start', component: FormStart },
  feedback: { path: '/form/:authenticationCode/feedback', component: Feedback },
  formEnd: { path: '/form/:authenticationCode/end', component: FormEnd },
  reviewEdit: {
    path: '/form/:authenticationCode/review/:formSetId/:formId/edit/:sectionType',
    component: ReviewEditPage,
  },
  review: {
    path: '/form/:authenticationCode/review/:formSetId/:formId',
    component: ReviewPage,
  },
  recommendation: {
    path: '/form/:authenticationCode/recommendations',
    component: RecommendationPage,
  },
  form: {
    path: '/form/:authenticationCode/:formSetId/:formId',
    component: Form,
  },
};

function getRouteComponents(): JSX.Element[] {
  return Object.entries(routes).map(([key, route]) => {
    return (
      <Route
        key={key}
        exact={route.exact}
        path={route.path}
        component={route.component}
      />
    );
  });
}

export const FormRouter: React.FC = () => (
  <Switch>{getRouteComponents()}</Switch>
);
